import { Builder, Input } from '@builder.io/sdk';
import { PageHeroImage } from './PageHeroImage';
import { landingPageFormInputs } from '../LandingPageForm/LandingPageForm.registry';

const getFormInputs = (): Input[] => {
  const excludedFields = ['heading', 'subHeading', 'useCardStyle'];

  const defaultOverrides: Record<string, string | boolean> = {
    regLabel: 'Enter Registration Number',
    defaultDurationType: '2 days',
  };

  const overrideDefaults = (input: Input): Input => {
    if (input.name in defaultOverrides) {
      return { ...input, defaultValue: defaultOverrides[input.name] };
    }
    return input;
  };

  return landingPageFormInputs.filter((input) => !excludedFields.includes(input.name)).map(overrideDefaults);
};

const ProductHeroImageConfig = {
  name: 'PageHeroImage',
  inputs: [
    {
      name: 'title',
      type: 'string',
      required: true,
    },
    {
      name: 'subtitle',
      type: 'string',
      required: false,
    },
    ...getFormInputs(),
    {
      name: 'image',
      type: 'file',
      required: true,
    },
  ] as Input[],
};

Builder.registerComponent(PageHeroImage, ProductHeroImageConfig);
